var map = {
	"./1.png": 640,
	"./10.png": 641,
	"./11.png": 642,
	"./12.png": 643,
	"./13.png": 644,
	"./14.png": 645,
	"./15.png": 646,
	"./16.png": 647,
	"./17.png": 648,
	"./18.png": 649,
	"./19.png": 650,
	"./2.png": 651,
	"./20.png": 652,
	"./21.png": 653,
	"./22.png": 654,
	"./23.png": 655,
	"./24.png": 656,
	"./25.png": 657,
	"./26.png": 658,
	"./27.png": 659,
	"./28.png": 660,
	"./29.png": 661,
	"./3.png": 662,
	"./30.png": 663,
	"./4.png": 664,
	"./5.png": 665,
	"./6.png": 666,
	"./7.png": 667,
	"./8.png": 668,
	"./9.png": 669
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 670;